import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import Spin from 'components/Spin';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadListPins } from 'store/Orbita/Invoice/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes: any;
  invoice: any;
  pinsList: any;
  isFetching: any;
}

interface IStates {
  openedLinks: boolean;
}

class Pins extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      openedLinks: false,
    };
  }

  showListPins = () => {
    (async () => {
      try {
        await this.props.dispatch(loadListPins(this.props.invoice.id));
      } catch (error) {
        toast.error(error);
      }
    })();
  };

  handleClickLoadPins = () => {
    if (!this.state.openedLinks) {
      this.setState({
        openedLinks: true,
      });

      this.showListPins();
    }
  };

  render() {
    const { classes, pinsList } = this.props;
    return (
      <div className={classes.access}>
        <h4>PINS</h4>
        <div className='access__content'>
          <div className='access__row'>
            {/* pins */}
            <MyCollapse onClick={this.handleClickLoadPins} title='Lista de PINS entregues' arrow={true} contentActive={false}>
              {this.props.isFetching && (
                <div className='loading' style={{ height: '100%' }}>
                  <Spin tip='Carregando ...' />
                </div>
              )}
              {!this.props.isFetching && Array.isArray(pinsList) && !pinsList.length && <p style={{ fontSize: '14px' }}>Nenhum PIN disponível</p>}
              {!this.props.isFetching && pinsList?.error && (
                <p style={{ fontSize: '14px' }}>
                  Algo deu errado ao carregar os PINS.{' '}
                  <b style={{ cursor: 'pointer' }} onClick={this.showListPins} role='button'>
                    Clique aqui para tentar novamente.
                  </b>
                </p>
              )}
              {Array.isArray(pinsList) &&
                pinsList.map((pin: any, i: number) => (
                  <div style={{ width: '100%', margin: '10px 0' }} key={'login-' + i}>
                    <CustomCopyToClipboard fullWidth={false} key={'urls' + i} text={pin.key} disableUnderline={true} />
                  </div>
                ))}
            </MyCollapse>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    pinsList: state.orbita.Invoice.loadPins,
    isFetching: state.orbita.Invoice.loadPins.isFetching,
  };
}

export default connect(mapStateToProps)(Pins);
